import {EToastMessageSeverity} from '@app/shared/enums/toast-message.enum';
import {TranslateService} from '@ngx-translate/core';
import {MessageService} from 'primeng/api';
import {ToastMessageUtils} from './toast-message.utils';

export class ErrorHandlerUtils {
  static getErrorMessage(translate: TranslateService, statusCode: number): string {
    let errorMessage = '';
    switch (statusCode) {
      case 400:
        errorMessage = translate.instant('Common.400_Error');
        break;
      case 401:
        errorMessage = translate.instant('Common.401_Error');
        break;
      case 404:
        errorMessage = translate.instant('Common.404_Error');
        break;
      case 403:
        errorMessage = translate.instant('Common.403_Error');
        break;
      case 500:
        errorMessage = translate.instant('Common.500_Error');
        break;
      default:
        errorMessage = translate.instant('Common.Failure');
        break;
    }
    return errorMessage;
  }

  static showErrorMessage(messageService: MessageService, toastKey: string, errorMessage: string): void {
    ToastMessageUtils.showMessage({
      messageService: messageService,
      toastKey: toastKey,
      severity: EToastMessageSeverity.Error,
      messageDetail: errorMessage,
    });
  }
}
